import { z } from 'zod';

// ============================================================================
// Multiplier management request schemas
// ============================================================================

export const SetMultiplierRequestSchema = z.object({
  ticketTypeId: z.string().min(1, 'ticketTypeId is required'),
  dateFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'dateFrom must be in YYYY-MM-DD format'),
  dateTo: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'dateTo must be in YYYY-MM-DD format'),
  multiplier: z.number().min(0.7).max(2.0),
  reason: z.string().min(1, 'reason is required'),
  priority: z.number().int().min(1).max(100).optional().default(10),
});

export type SetMultiplierRequest = z.infer<typeof SetMultiplierRequestSchema>;
